import BasketDesktop from 'components/BasketPage/BasketDesktop/BasketDesktop';
import BasketMain from 'components/BasketPage/BasketMain/BasketMain';
import BasketMobile from 'components/BasketPage/BasketMobile/BasketMobile';
import Backdrop from 'components/Common/Backdrop/Backdrop';
import Layout from 'components/Layout/Layout';
import React from 'react';
import styles from './BasketPage.module.scss';

const BasketPage = () => {
  return (
    <Layout>
      <div className={styles.basketPage}>
        <BasketMain desktopRender={BasketDesktop} mobileRender={BasketMobile} />
        <Backdrop />
      </div>
    </Layout>
  );
};

export default BasketPage;
